// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__Gy+mg"};